<template>
  <div>
   <el-container>
  		<el-main>
  			<el-row :gutter="20">
		  		<el-col :span="24" :offset="6" :md="12">
		  			<div class="auth-header">
		  				<img src="../../assets/logo.png">
		  			</div>
		  			<div class="signup-body auth-panel">
		  				<steps step3="1"></steps>

              <el-form class="auth-form" label-position="top" label-width="100px" :model="userData">
              	<div id="card-element"></div>
                <div id="card-errors" role="alert"></div>
    
                <el-row :gutter="40">
                  <el-form-item  style=" width:300px; float:right;" label="Promo Code">
                      <el-input  style="float:left; display:inline-block; " placeholder="Enter Code" class="text-center" v-model="userData.promoCode"></el-input><el-button  style="float:left; display:inline-block; width:100%;" size="mini" @click="applyPromocode" type="default">Apply</el-button>
                    </el-form-item>
         			<el-col class="order-review" :span="24">
         				<h1>Your Order</h1>
         				<p v-for="plan in selectedPlans">{{plan.name}} <span>${{plan.price}}</span></p>
         				<p>Service Fee <span>${{fee}}</span></p>
         			</el-col>
         		</el-row>
            <el-row :gutter="40">
         			<el-col class="total-container" :span="12">
         				<h3>Total: ${{total}}</h3>
         			</el-col>
         			<el-col class="next-container" :span="12">
         				<el-button v-show="!savingData" @click.native="makePayment"  type="primary">Pay Now</el-button>
         				<el-button v-show="savingData" :loading="true" type="primary">Pay Now</el-button>
         			</el-col>
         		</el-row>
               
              </el-form>
               
		  			</div>
		  		</el-col>
			</el-row>
  		</el-main>
	</el-container>
	<logout></logout>
  </div>
</template>

<script>
import Steps from './steps';
import Logout from './logout' ;

export default {
  name: 'checkout',
  components:{
    Steps,
    Logout
  },
  methods:{
    applyPromocode:function(){
      var _this = this;
      var user = Parse.User.current();
      if(this.userData.promoCode =="LLWZATC"){
        var payload = {
            products: user.get('selectedPlans'),
            email: user.get('email'),
            firstName: user.get('firstName'),
            lastName:user.get('lastName')
          };
        user.set('promoCode', "LLWZATC");
        user.save()
          .then(function(savedUser){
            return Parse.Cloud.run('submitPromocode', payload );
          })
          .then(function(resp){
            console.log("SUCCESS");
            _this.savingPromo = false;
            _this.$router.push('/dashboard/');
          })
          .catch(function(err){
            console.log(err);
            console.log("ERROR");
            _this.savingPromo = false;
            alert('There was an error, please contact support.');
          });
        
      } else {
        alert("This promocode is not valid!")
      }
    },
  	makePayment:function(){
  		var _this = this;
  		_this.savingData = true;
  		console.log(_this.cardObject);
  		stripe.createToken(_this.cardObject).then(function(result) {
		    if (result.error) {
		    	_this.savingData = false;
		      // Inform the customer that there was an error.
		      var errorElement = document.getElementById('card-errors');
		      errorElement.textContent = result.error.message;
		    } else {
		      // Send the token to your server.
		      _this.stripeTokenHandler(result.token);

		    }
		  });
  		
  	},
  	calculateFee: function(amount){
  		this.fee =  (this.subTotal+0.3)/(1-0.029)- this.subTotal;
  		this.total = this.subTotal + this.fee;
  		this.fee = this.fee.toFixed(2);
  		this.total = this.total.toFixed(2);
  	},
  	stripeTokenHandler: function(token){
  		var _this = this;
  		var user = Parse.User.current();

  		var payload = {
		      	stripeToken: token.id,
		      	products: user.get('selectedPlans'),
		      	email: user.get('email'),
            firstName: user.get('firstName'),
            lastName:user.get('lastName')
		      };
		Parse.Cloud.run('registrationPayment', payload)
			.then(function(customerId){
				var price = 0;
				for (var i = 0; i < user.attributes.selectedPlans.length; i++) {
					price+=user.attributes.selectedPlans[i].price;
				}
			  	


				user.set('stripeId', customerId);
				return user.save();

				fbq('track','Purchase', {
				    value: price,
				    currency: 'usd',
			  	});
				
			}).then(function(resp){
				console.log("SUCCESS");
				_this.savingData = false;
				_this.$router.push('/dashboard/');
			}).catch(function(error){
				console.log("ERRROR");
				 console.log(error);
				 _this.$message({
				 	type:'error',
				 	message:error.message,
				 	showClose: true
				 });
				_this.savingData = false;
			});
  	}
  },
  mounted: function () {
  	 console.log("MOUNTED");

  	  var elements = stripe.elements();
  	  // Custom styling can be passed to options when creating an Element.
		var style = {
		  base: {
		    // Add your base input styles here. For example:
		    fontSize: '16px',
		    color: "#666"
		  }
		};

		// Create an instance of the card Element.
		var card = elements.create('card', {style: style});

		// Add an instance of the card Element into the `card-element` <div>.
		card.mount('#card-element');
  	  var user = Parse.User.current();
  	  if(!user){
  	  	this.$router.push('/login');
  	  	return;
  	  }
  	  console.log('USER');
  	  console.log(user);
  	  this.selectedPlans = user.get('selectedPlans');
  	  this.subTotal = 0;
  	  for (var i = 0; i < this.selectedPlans.length; i++) {
  	  	this.subTotal += this.selectedPlans[i].price;
  	  }
  	  this.calculateFee(this.total);
  	  card.addEventListener('change', function(event) {
		  var displayError = document.getElementById('card-errors');
		  if (event.error) {
		    displayError.textContent = event.error.message;
		  } else {
		    displayError.textContent = '';
		  }
		});
  	  this.cardObject = card;
  	  console.log(card);
  	  var user = Parse.User.current();
  },
  data () {
    return {
    	cardObject: null,
      selectedPlans: [],
      fee:0,
      subTotal: 15,
      total: null,
      savingData: false,
      userData:{
        firstName:"",
        lastName:"",
        email:"",
        password:"",
        passwordConfirm:""
      },
      msg: 'Welcome to Your Vue.js App'
    };
  }
}
</script>

<style>
.auth-form {
  padding: 20px 0 0;
}
.auth-form .el-form-item{
  margin-bottom: 15px;
}
.auth-form label.el-form-item__label{
  width: 100%;
  padding: 0;
  line-height: 24px;
}

.auth-form button.el-button--primary{
  width: 100%;
  margin-top: 10px;
}

.order-review { 
text-align: left;
}
.order-review h1{
	color: #666;
	font-size: 20px;
	border-bottom: 1px solid #EEE;
	padding-bottom: 5px;
}
.order-review p {
	color: #666;
	padding: 0 10px 10px;
	border-bottom: 1px solid #EEE;
}
.order-review p span{
	float: right;
}
.text-center .el-input__inner {
	text-align: center;
}
#card-element {
	border:1px solid #EEE;
	padding: 10px;
	border-radius: 4px;
	margin-bottom: 20px;
}
</style>
